import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class LoginService {

    constructor() {
        this.httpClient = new HttpClient()
        this.url = process.env.REACT_APP_KECLOACK_URL
        this.globalUrl = process.env.REACT_APP_BASE_URL
    }

    loginUser(userName, password) {
        let formData = new URLSearchParams()

        formData.append("username", userName)
        formData.append("password", password)

        formData.append("client_id", this.httpClient.getClientId())
        formData.append("client_secret", process.env.REACT_APP_CLIENT_SECRET)
        formData.append("grant_type", "password")

        return new Promise((resolve, reject) => {

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(resolve).catch(reject)
        })

    }

    getAccessInfo(token) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/admins/access-information`,
                {},
                {
                    "Authorization": this.httpClient.convertToken(token),
                    'Content-Type': "application/json"
                }
            ).then(resolve).catch(reject)
        })
    }

    sendVerificationCode(username, password, key) {

        return new Promise((resolve, reject) => {

            new HttpClient(
                {},
                "application/json",
                process.env.REACT_APP_BASE_URL
            )
                .post(
                    `presentation/managers/otp/sms`,
                    {
                        "username": username,
                        "password": password
                    }
                )
                .then(resolve).catch(reject)
        })
    }

    sendOtpSmsForgetPassword(phoneNumber, nationalCode) {
        return new Promise((resolve, reject) => {
            new HttpClient({}, "application/json", process.env.REACT_APP_BASE_URL)
                .post(
                    "presentation/otp/sms",
                    {
                        "phoneNumber": phoneNumber,
                        "nationalCode": nationalCode,
                        "otpKind": "MANAGER"
                    }
                ).then(resolve).catch(reject)
        })
    }

    updateForgotPassword(username, newPassword, phoneNumber, otp) {
        let formData = new URLSearchParams()
        formData.append("phoneNumber", phoneNumber)
        formData.append("newPassword", newPassword)
        formData.append("username", username)
        formData.append("otp", otp)

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }

        return new Promise((resolve, reject) => {
            new HttpClient(
                config,
                'application/x-www-form-urlencoded'
            ).post("admins/password/reset", formData
            ).then(resolve).catch(reject)
        })
    }

    getUserTokenByRefreshToken(refreshToken) {

        let formData = new URLSearchParams()
        formData.append("refresh_token", refreshToken)
        formData.append("client_id", this.httpClient.getClientId())
        formData.append("client_secret", this.httpClient.getClientSecret())
        formData.append("grant_type", "refresh_token")

        return new Promise((resolve, reject) => {

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(response => {
                    resolve(response)
                }).catch(reason => {
                reject(reason)
            })


        })
    }
}